import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import { Grid } from "@mui/material";
import JumboDemoCard from "@jumbo/components/JumboDemoCard";
import { CleaningServices, WidthFull } from "@mui/icons-material";
import { getCoursesByUser, toggleCourseApi } from "backendServices/ApiCalls";
import { useLocation } from "react-router-dom";

const EnrolledCourses = () => {
  const [list, setList] = useState([]);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const user_id = location?.state?.user_id || "";

  const getCourses = () => {
    setIsLoading(true);
    getCoursesByUser(
      user_id,
      (response) => {
        const processedData = response?.data?.data?.map((row, index) => ({
          ...row,
          index: index + 1,
        }));
        setList(processedData || []);
        setIsLoading(false);
      },
      (error) => {
        setIsLoading(false);
        console.log(error);
      }
    );
    setIsLoading(false);
  };

  useEffect(() => {
    getCourses();
  }, []);

  const handleBlock = (c) => {
    const params = {
      userId: user_id,
      courseId: c?.id,
      toggle: c?.isOpen ? 0 : 1,
    };
    setIsLoading(true);
    toggleCourseApi(
      params,
      (response) => {
        getCourses();
      },
      (error) => {
        setIsLoading(false);
        console.log(error);
      }
    );
    setIsLoading(false);
  };

  return (
    <Grid container fullWidth sm={12} xs={12} p={2} className="enrolled_cont">
      <JumboDemoCard
        title={<h3>{"Enrolled Courses"}</h3>}
        wrapperSx={{
          backgroundColor: "background.paper",
          pt: 0,
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "10px",
            flexWrap: "wrap",
            width: "100%",
          }}
        >
          {list?.length ? (
            list?.map((c) => {
              return (
                <Card sx={{ maxWidth: 345 }}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      height="140"
                      image="https://images.unsplash.com/photo-1758846182558-ebf26988c813?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                      alt="green iguana"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        {c?.title || ""}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "text.secondary" }}
                      >
                        {c?.description}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions>
                    <Button
                      size="medium"
                      sx={{
                        background: "#7352C7",
                        color: "white",
                        "&:hover": {
                          background: "#7352C7",
                        },
                      }}
                      onClick={() => handleBlock(c)}
                    >
                      {c?.isOpen ? "Block" : "Unblock"}
                    </Button>
                  </CardActions>
                </Card>
              );
            })
          ) : (
            <div>
              <h1>No Enrolled Courses are available.</h1>
            </div>
          )}
        </div>
      </JumboDemoCard>
    </Grid>
  );
};

export default EnrolledCourses;
